<template>
  <div style="background-color: rgb(233, 236, 246)">
    <v-menu v-model="showMenu" class="menu-style-task" top right min-width="140px" max-width="200px" max-height="600px"
      :position-x="xShowPosition" :position-y="yShowPosition" absolute>
      <v-list dense>
        <v-subheader light :style="{ 'background-color': 'whitesmoke' }">{{ $i18n.t("ppt_menus_length.menu_title") }}</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item v-for="menu in lengthMenus" :key="menu.id" @click="onSelectMenu(menu)" @mousemove="onMouseMove"
            @mouseover="expandSubMenu(menu)">
            <v-list-item-content>
              <v-list-item-subtitle class="text-xs">{{ menu.title }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-show="menu.hasSubMenus">
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-list dense>
        <v-subheader light :style="{ 'background-color': 'whitesmoke' }">{{ $i18n.t("ppt_menus_tone.menu_title") }}</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item v-for="menu in toneMenus" :key="menu.id" @click="onSelectMenu(menu)" @mousemove="onMouseMove"
            @mouseover="expandSubMenu(menu)">
            <v-list-item-content>
              <v-list-item-subtitle class="text-xs">{{ menu.title }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-show="menu.hasSubMenus">
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-menu v-model="showSubMenu" class="menu-style-task" top right min-width="140px" max-width="200px" max-height="600px"
      :position-x="xShowSubMenu" :position-y="yShowSubMenu" absolute>
      <!-- <v-card-subtitle
        class="font-weight-bold text-2xl"
        :style="{ 'background-color': 'whitesmoke' }"
        >请选择:</v-card-subtitle
      > -->
      <!-- <v-subheader>请选择:</v-subheader> -->
      <v-divider />
      <v-list>
        <v-list-item v-for="menu in subMenuItems" :key="menu.id" @click="onSelectSubMenu(menu)">
          <v-list-item-content>
            <v-list-item-subtitle class="text-xs">{{ menu.title }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { userKeys, wdConfigData} from "@/service/wd_app_config.js";
import { get } from "vuex-pathify";
import { i18n } from "@i18n";
import aiMenusZh from "@/store/modules/aiMenus-zh";
import aiMenusEn from "@/store/modules/aiMenus-en";

//例如: import <组件名称> from  <组建路径>

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      lengthMenus:[],
      toneMenus:[],
      showMenu: false,
      xShowPosition: 0,
      yShowPosition: 0,

      showSubMenu: false,
      xShowSubMenu: 0,
      yShowSubMenu: 0,
      subMenuItems: [],

      mouseOffsetX: 0,
      mousePageY: 0,
    };
  },
  //计算机属性 类似与data概念
  computed: {
    ...get("gpt", ["lengthMenus", "toneMenus"]),
  },
  //监控data中数据变化
  watch: {},
  methods: {
    funcShowMenu(e) {
      this.showMenu = true;
      this.xShowPosition = e.$el.offsetLeft;
      this.yShowPosition = e.$el.offsetTop; // 加上AppBar的高度
    },
    funcHideMenu() {
      this.showMenu = false;
      this.showSubMenu = false;
    },
    onSelectMenu(menu) {
      // if (menu.subMenus == undefined) {
        this.$emit("onClickMenu", menu);
      // }
      // this.$emit("clearInput");
    },
    onMouseMove(e) {
      this.mouseOffsetX = e.offsetX;
      this.mousePageY = e.pageY;
    },
    expandSubMenu(menu) {
      this.showSubMenu = menu.hasSubMenus;
      if (menu.hasSubMenus) {
        this.xShowSubMenu =
          this.xShowPosition + this.mouseOffsetX < 150
            ? 150
            : this.mouseOffsetX;
        this.yShowSubMenu = this.mousePageY;
        this.subMenuItems = menu.subMenus;
      }
    },
    onSelectSubMenu(menu) {
      this.showMenu = false;
      this.showSubMenu = false;
      this.$emit("onClickMenu", menu);
      this.$emit("clearInput");
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() { },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    i18n.locale = wdConfigData.localLanguage
    if (i18n.locale == "zhHans") {
      this.toneMenus = aiMenusZh.state.toneMenus
      this.lengthMenus = aiMenusZh.state.lengthMenus
    } else {
      this.toneMenus = aiMenusEn.state.toneMenus
      this.lengthMenus = aiMenusEn.state.lengthMenus
    }
   },
  destroyed() { }, //生命周期-销毁完成
  activated() { }, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
